import axios from "axios"
import url from "../utils/url";

export const postearOperacion = async (dataOperacion) => {
    return await axios.post(`${url}/api/infoMotosCotizadas/`, dataOperacion);
}

export const postearCotizacion = async (cotizacionTablaData) => {
    return await axios.post(`${url}/api/cotizaciones/`, cotizacionTablaData);
}